import React from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import CommonModal from 'components/elements/modals/CommonModal';

import './TurnOffEarnModal.css';

const TurnOffEarnModal = ({
  earnModalOpen,
  setEarnModalOpen,
  onTurnOffEarn,
}) => (
  <CommonModal
    className="earn-switcher-turn-off-modal__component"
    open={earnModalOpen}
    onClose={() => { setEarnModalOpen(false); }}
  >
    <div className="wrapper">
      <div className="text-content">
        <b>
          {i18n.t("Are you sure you want to turn off")}<br />
          {i18n.t("advertising on your HeyLink.me page")}<br />
        </b>
        {i18n.t("and stop earning money?")}
      </div>
      <div className="buttons-block">
        <div
          className="modal-button"
          onClick={() => { setEarnModalOpen(false); }}
          role="button"
          tabIndex={-1}
        >
          {i18n.t("Cancel")}
        </div>

        <div
          className="modal-button confirm"
          onClick={() => { onTurnOffEarn(); }}
          role="button"
          tabIndex={-1}
        >
          {i18n.t("Yes, stop earning money")}
        </div>
      </div>
    </div>
  </CommonModal>
);

TurnOffEarnModal.propTypes = {
  earnModalOpen: PropTypes.bool,
  setEarnModalOpen: PropTypes.func,
  onTurnOffEarn: PropTypes.func,
};
TurnOffEarnModal.defaultProps = {
  earnModalOpen: false,
  setEarnModalOpen: null,
  onTurnOffEarn: null,
};

export default TurnOffEarnModal;
